//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PcbExchange.js";
import "../no/Builder.js";
let d=[[[0,"BoardFile",1,0],[0,"EcadLocation",1,0],[0,"ItemRevision",1,0],[0,"ShowLog",1,0],[0,"UpdateOption",1,0],[0,"UpdateTarget",1,0]],[[[],"Compare",{},0,0],[[],"ShowComparisonDetails",{},0,0],[["variantName","canUpdate"],"SetUpdate",{},2,0]],[]];
SPLM.PcbExchange.VariantManagerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PcbExchange.VariantManagerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PcbExchange.VariantManagerBuilder.EcadLocationEnum = Object.freeze({
    "Local" : "Local", "Dataset" : "Dataset", "ItemRevision" : "ItemRevision", "VariantRelationship" : "VariantRelationship"});

SPLM.PcbExchange.VariantManagerBuilder.UpdateOptionEnum = Object.freeze({
    "All" : "All", "None" : "None", "Specify" : "Specify"});

SPLM.PcbExchange.VariantManagerBuilder.UpdateTargetEnum = Object.freeze({
    "External" : "External", "Current" : "Current"});

export default SPLM;